import React, { createContext, useState, useContext } from 'react';
import styled from 'styled-components';

const NotificationContext = createContext();

export const useNotification = () => useContext(NotificationContext);

export const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState({ show: false, message: '', type: 'info' });

  const showNotification = (message, type = 'info') => {
    setNotification({ show: true, message, type });

    // Auto-hide notification after 4 seconds
    setTimeout(() => {
      setNotification({ show: false, message: '', type: 'info' });
    }, 4000);
  };

  return (
    <NotificationContext.Provider value={{ showNotification }}>
      {children}
      {notification.show && (
        <NotificationBar className={notification.type}>
          {notification.message}
          <CloseButton onClick={() => setNotification({ ...notification, show: false })}>
            ×
          </CloseButton>
        </NotificationBar>
      )}
    </NotificationContext.Provider>
  );
};

// Styled Components moved from PaymentPage.js
const NotificationBar = styled.div`
  position: fixed;
  top: 20px;
  inset-inline-end: 20px;
  padding: 15px 25px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 400px;
  z-index: 1000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  
  &.info {
    background-color: #f0f7ff;
    border-inline-start: 4px solid #3498db;
    color: #2980b9;
  }
  
  &.success {
    background-color: #f0fff4;
    border-inline-start: 4px solid #2ecc71;
    color: #27ae60;
  }
  
  &.error {
    background-color: #fff5f5;
    border-inline-start: 4px solid #e74c3c;
    color: #c0392b;
  }
  
  @media (max-width: 576px) {
    inset-inline-start: 20px;
    inset-inline-end: 20px;
  }
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  margin-inline-start: 10px;
  opacity: 0.7;
  
  &:hover {
    opacity: 1;
  }
`;
